import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ToastsManager} from 'ng2-toastr';
import {AppService} from '../../appService';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';

@Component({
  selector: 'app-single-student-mentoring-by-associatehead',
  templateUrl: './single-student-mentoring-by-associatehead.component.html',
  styleUrls: ['./single-student-mentoring-by-associatehead.component.css']
})
export class SingleStudentMentoringByAssociateheadComponent implements OnInit {
  summaryResultCourseCodeOrTitleFilter: any = '';
  detailsResultCourseCodeOrTitleFilter: any = '';
  attendanceCourseCodeOrTitleFilter: any = '';

  teacherId: any = '';
  attendanceList: any = [];
  studentId: any = '';
  singleStudentDetails: any = {};
  semesterList: any = [];
  semesterIdToSearchSingleStudentResult = '';
  semesterIdToSearchSingleStudentAttendance = '';

  brifDescription: any = '';
  personalInterest: any = '';
  initialProblem: any = '';
  strangthOfStudent: any = '';
  weaknessOfStudent: any = '';
  additionalInfoOfStudent: any = '';

  singleStudentResultSummery: any = {};
  singleStudentPaymentLedgerSummery: any = {};
  semesterIdToSearchSingleStudentResultDetails = '';
  singleStudentResultDetailsList: any = [];
  singleStudentResultList: any = [];
  singleStudentSgpaList: any = [];
  singleStudentPaymentHistory: any = {};
  singleStudentCounsellingHistory: any = {};
  photograph: any = '';

  constructor(private appService: AppService,
              private localStorage: LocalStorageService,
              private sessionStorage: SessionStorageService,
              private route: ActivatedRoute,
              private router: Router, private httpClient: HttpClient,   public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.appService.hasAccessToken();
    this.route.params.subscribe((params: Params) => {
      this.studentId = params['studentId'];
      this.teacherId = params['teacherId'];
    });

    // console.log(this.studentId);
    // console.log(this.teacherId);

    this.getSingleStudentDetails();
    this.getSingleStudentObservation();
    this.getSemesterList();
    this.getSingleStudentResultSummery();
    this.getSingleStudentPaymentLedgerSummery();
    this.getSingleStudentSgpaList();
    this.getSingleStudentCounsellingHistory();
    this.getSingleStudentPaymentHistory();
  }

  // ok
  getSemesterList() {
    const myParams = new HttpParams();
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/semesterList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          // console.log(res);
          this.semesterList = res;
        },
        msg => {
          console.error('error');
        }
      );
  }

  // ok
  getSingleStudentObservation() {
    const myParams = new HttpParams().append('studentId', this.studentId).append('teacherId', this.teacherId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentObservation', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          // console.log(res);

          this.brifDescription = res['brifDescription'];
          this.personalInterest = res['personalInterest'];
          this.initialProblem = res['initialProblem'];
          this.strangthOfStudent = res['strangthOfStudent'];
          this.weaknessOfStudent = res['weaknessOfStudent'];
          this.additionalInfoOfStudent = res['additionalInfoOfStudent'];
        },
        msg => {
          console.error('error');
        }
      );
  }

  // ok
  getSingleStudentPhotograph(personId) {
    // console.log('personId ', personId);

    const myParams = new HttpParams().append('personId', personId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentPhotograph', {
      headers: this.appService.getHeadersWithAccessToken(),
      responseType: 'text',
      params: myParams
    })
      .subscribe(res => {
          // console.log(res);
          this.photograph = 'data:image/jpeg;base64,' + res;
        },
        msg => {
          console.error('error');
        }
      );
  }

  // ok
  getSingleStudentResultSummery() {
    const myParams = new HttpParams().append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentResultSummery', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentResultSummery = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }


  getSingleStudentPaymentLedgerSummery() {
    const myParams = new HttpParams().append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentPaymentLedgerSummery', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentPaymentLedgerSummery = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }
  getSingleStudentPaymentHistory() {
    const myParams = new HttpParams().append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentRecentPayment', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentPaymentHistory = res;
          this.getSingleStudentCounsellingHistory();
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }

  getSingleStudentCounsellingHistory() {
    const myParams = new HttpParams().append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentCounselling', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentCounsellingHistory = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }

  getSingleStudentSgpaList() {
    const myParams = new HttpParams().append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentSgpaList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentSgpaList = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }

  getSingleStudentDetails() {
    const myParams = new HttpParams().append('studentId', this.studentId).append('teacherId', this.teacherId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/v2/singleStudentDetails', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentDetails = res;
           // console.log(res);

          if ( res !== null || res !== undefined) {
            this.getSingleStudentPhotograph(this.singleStudentDetails['photo'].personId);
          }

        },
        msg => {
          console.error('error');
        }
      );
  }

  // ok
  getSingleStudentResultDetailsList() {

    const myParams = new HttpParams().append('semesterId', this.semesterIdToSearchSingleStudentResultDetails).append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentResultDetailsList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentResultDetailsList = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }

  // ok
  getSingleStudentResultList() {

    const myParams = new HttpParams().append('semesterId', this.semesterIdToSearchSingleStudentResult).append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentResultList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentResultList = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }



  getAttendanceList() {
    const myParams = new HttpParams().append('semesterId', this.semesterIdToSearchSingleStudentAttendance).append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'associateHeadAccess/singleStudentAttendanceList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.attendanceList = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }

  getPresentAttendanceTotal(attendance) {
    let count = 0;
    const objectKey = Object.keys(attendance);
    for (let i = 0; i < objectKey.length; i++) {
      if (objectKey[i].startsWith('A')) {
        const paramValue = attendance[objectKey[i]];
        if (paramValue) { count += 1; }
      }
    }
    return count;
  }
}
